import { render, staticRenderFns } from "./index.vue?vue&type=template&id=541f2e4f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('541f2e4f')) {
      api.createRecord('541f2e4f', component.options)
    } else {
      api.reload('541f2e4f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=541f2e4f", function () {
      api.rerender('541f2e4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/objectAdminList/index.vue"
export default component.exports